import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { communityPageStateStore } from "./communityPageStore";
import { CommunityState, communityStore } from "./communityStore";
import {
    EventDetailsRenderState,
    eventDetailsPageStore,
} from "./eventDetailsRenderStore";
import { imageStore } from "./imageStore";
import { leftSideBarStateStore } from "./leftSideBarStore";
import { RenderState, renderStore } from "./renderStore";
import { UserState, userStore } from "./userStore";
import useFilterStore from "./globalFilterStore";
import { followingStore } from "./followingStore";
import { homePageRenderStore } from "./homepageRenderStore";

export type StoreSchema = UserState &
    RenderState &
    CommunityState &
    EventDetailsRenderState;

export const useUserStore = create(
    devtools(userStore, {
        name: "userStore",
    }),
);

export const useFollowingStore = create(
    devtools(
        persist(followingStore, {
            name: "followingStore",
            getStorage: () => sessionStorage,
        }),
        {
            name: "followingStore",
        },
    ),
);

export const useCommunityStore = create(
    devtools(
        persist(communityStore, {
            name: "communityStore",
            getStorage: () => localStorage,
        }),
        {
            name: "communityStore",
        },
    ),
);

export const useRenderStore = create(
    devtools(renderStore, {
        name: "renderStore",
    }),
);

export const useImageStore = create(
    devtools(imageStore, {
        name: "imageStore",
    }),
);

export const useEventDetailsPageStore = create(
    devtools(eventDetailsPageStore, {
        name: "userEventDetailsStateStore",
    }),
);

export const useCommunityPageStore = create(
    devtools(communityPageStateStore, {
        name: "userCommunityPageStateStore",
    }),
);

export const useCommunityRenderStore = create(
    devtools(eventDetailsPageStore, {
        name: "userEventDetailsStateStore",
    }),
);

export const useLeftSideBarStore = create(
    devtools(leftSideBarStateStore, {
        name: "userEventDetailsStateStore",
    }),
);

export const useHomePageRenderStore = create(homePageRenderStore);

export const clearStores = () => {
    useUserStore.getState().clear();
    useFollowingStore.getState().clear();
    useCommunityStore.getState().clear();
    useRenderStore.getState().clear();
    useImageStore.getState().clear();
    useEventDetailsPageStore.getState().clear();
    useCommunityPageStore.getState().clear();
    useCommunityRenderStore.getState().clear();
    useLeftSideBarStore.getState().clear();
    useFilterStore.getState().resetFilter();
    useHomePageRenderStore.getState().clear();
};
